import {motion} from 'motion/react';
import Image from 'next/image';
import styles from './loading.module.scss';

const Loading = () => {
    return (
        <motion.div className={styles.loadingContainer}>
            <Image
                src="/ci/images/landing/icons/loader.gif"
                alt="Loading"
                width={100}
                height={100}
            />
        </motion.div>
    );
};

export {Loading};
